module.exports = __webpack_public_path__ + "img/番外_学电视剧_03_冰箱.22ed9c0e.png";